import { render, staticRenderFns } from "./PixelManagement.vue?vue&type=template&id=5cc10117&"
import script from "./PixelManagement.vue?vue&type=script&lang=js&"
export * from "./PixelManagement.vue?vue&type=script&lang=js&"
import style0 from "./PixelManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports